var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "enabled", color: "primary", label: "" },
                model: {
                  value: _vm.enabled,
                  callback: function ($$v) {
                    _vm.enabled = $$v
                  },
                  expression: "enabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            _vm._s(_vm.$t("admin.integration_defectdojo_enable")) + "\n    "
          ),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "reimport-enabled", color: "primary", label: "" },
                model: {
                  value: _vm.reimportEnabled,
                  callback: function ($$v) {
                    _vm.reimportEnabled = $$v
                  },
                  expression: "reimportEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            _vm._s(_vm.$t("admin.integration_defectdojo_reimport_enable")) +
              "\n    "
          ),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "defectdojo-cadence",
              label: _vm.$t("admin.synchronization_cadence_minutes"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "number",
              lazy: "true",
            },
            model: {
              value: _vm.cadence,
              callback: function ($$v) {
                _vm.cadence = $$v
              },
              expression: "cadence",
            },
          }),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("admin.synchronization_cadence_restart_required")
                ) +
                "\n    "
            ),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "defectdojo-url",
              label: _vm.$t("admin.url"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "url",
              lazy: "true",
            },
            model: {
              value: _vm.url,
              callback: function ($$v) {
                _vm.url = $$v
              },
              expression: "url",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "defectdojo-apiKey",
              label: _vm.$t("admin.api_token"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.apiKey,
              callback: function ($$v) {
                _vm.apiKey = $$v
              },
              expression: "apiKey",
            },
          }),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }